import {Box, LinearProgress, Paper, Typography} from '@mui/material';
import {startCase} from 'lodash';

export interface FeatureUsageRowProps {
  name: string;
  value: number;
  quota: number;
}

export default function FeatureUsageRow({name, value, quota}: FeatureUsageRowProps) {
  const percent = quota === Infinity ? 0 : Math.min(100, (value / quota) * 100);

  return (
    <Paper sx={{p: 2}}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1" sx={{minWidth: 180}}>
          {startCase(name.toLowerCase())}
        </Typography>
        <Box flex={1} mx={2}>
          <LinearProgress
            variant={quota === Infinity ? 'determinate' : 'determinate'}
            value={quota === Infinity ? 100 : percent}
            sx={{height: 10, borderRadius: 5, background: '#eee'}}
          />
        </Box>
        <Typography variant="body2" sx={{minWidth: 120, textAlign: 'right'}}>
          {value} / {quota === Infinity ? '∞' : quota}
        </Typography>
      </Box>
    </Paper>
  );
}
